var _circle, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSetupChangedIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#EBEFF7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.4998 20.9C38.8998 19.72 41.1598 19.72 42.5198 20.9L45.6798 23.6C46.2798 24.1 47.4198 24.52 48.2198 24.52H51.6198C53.7398 24.52 55.4798 26.26 55.4798 28.38V31.78C55.4798 32.58 55.8998 33.7 56.3998 34.3L59.0998 37.46C60.2798 38.86 60.2798 41.12 59.0998 42.48L56.3998 45.64C55.8998 46.24 55.4798 47.36 55.4798 48.16V51.56C55.4798 53.68 53.7398 55.42 51.6198 55.42H48.2198C47.4198 55.42 46.2998 55.84 45.6998 56.34L42.5398 59.04C41.1398 60.22 38.8798 60.22 37.5198 59.04L34.3598 56.34C33.7598 55.84 32.6198 55.42 31.8398 55.42H28.3398C26.2198 55.42 24.4798 53.68 24.4798 51.56V48.14C24.4798 47.36 24.0798 46.22 23.5798 45.64L20.8798 42.46C19.7198 41.08 19.7198 38.84 20.8798 37.46L23.5798 34.28C24.0798 33.68 24.4798 32.56 24.4798 31.78V28.4C24.4798 26.28 26.2198 24.54 28.3398 24.54H31.7998C32.5998 24.54 33.7198 24.12 34.3198 23.62L37.4998 20.9Z",
    stroke: "#3772FF",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40 32.26V41.92",
    stroke: "#3772FF",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9893 48H40.0072",
    stroke: "#3772FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetupChangedIcon);
export default __webpack_public_path__ + "static/media/SetupChangedIcon.358256d9e89b23c0f90ff889fd35b663.svg";
export { ForwardRef as ReactComponent };